export interface CommandSet {
  readonly allowed: ReadonlySet<string>;
}

/** レベル累積式のコマンド集合を作る（Lv1〜現在レベルの commands の和集合）。 */
export function commandSetFromLevels(levelsCommands: readonly (readonly string[])[]): CommandSet {
  const allowed = new Set<string>();
  for (const commands of levelsCommands) {
    for (const command of commands) {
      allowed.add(command);
    }
  }
  return { allowed };
}

/** 演習単位の明示リストで上書きする（指定時はレベル累積を使わず、そのリストのみを許可する）。 */
export function commandSetWithOverride(
  base: CommandSet,
  override: readonly string[] | undefined,
): CommandSet {
  if (override === undefined) {
    return base;
  }
  return { allowed: new Set(override) };
}

export function commandSetContains(commandSet: CommandSet, name: string): boolean {
  return commandSet.allowed.has(name);
}
